import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Clock, Package, CheckCircle, MapPin, ShieldCheck } from 'lucide-react';

const WhyUsSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Why Us?',
      subtitle: 'Your trusted partner in production.',
      items: [
        {
          icon: 'check',
          title: 'Consistent Quality at Any Volume',
          description: 'Same standards from first sample to full production.'
        },
        {
          icon: 'clock',
          title: 'Deadline-Driven',
          description: 'Built around your collection calendar.'
        },
        {
          icon: 'map',
          title: "Europe's Neighboring Factory",
          description: 'Istanbul-based. 2–3 days to Europe after dispatch.'
        },
        {
          icon: 'shield',
          title: 'Audit-Ready Production',
          description: 'OEKO-TEX · FSC · GRS · SEDEX · PETA Vegan'
        }
      ]
    },
    tr: {
      title: 'Neden Biz?',
      subtitle: 'Üretimde güvenilir ortağınız.',
      items: [
        {
          icon: 'check',
          title: 'Her Hacimde Tutarlı Kalite',
          description: 'İlk numuneden seri üretime aynı standartlar.'
        },
        {
          icon: 'clock',
          title: 'Termin Odaklı',
          description: 'Koleksiyon takviminize göre planlanır.'
        },
        {
          icon: 'map',
          title: "Avrupa'nın Komşu Fabrikası",
          description: 'İstanbul merkezli. Sevkiyattan sonra 2–3 günde Avrupa\'da.'
        },
        {
          icon: 'shield',
          title: 'Denetime Hazır Üretim',
          description: 'OEKO-TEX · FSC · GRS · SEDEX · PETA Vegan'
        }
      ]
    }
  };

  const t = content[language];

  const getIcon = (iconName) => {
    const iconProps = { size: 48, strokeWidth: 1.5, className: "text-gray-700" };
    switch (iconName) {
      case 'clock': return <Clock {...iconProps} />;
      case 'check': return <CheckCircle {...iconProps} />;
      case 'map': return <MapPin {...iconProps} />;
      case 'shield': return <ShieldCheck {...iconProps} />;
      default: return <Clock {...iconProps} />;
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-gray-500">
            {t.subtitle}
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16">
          {t.items.map((item, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-5">
                {getIcon(item.icon)}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-500">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
